import { Header } from 'antd/lib/layout/layout'
import TelusLogo from '../../../../assets/images/telus_logo.webp'
import classes from './Header.module.less'
import { UserProfile } from 'src/components/common/userProfile/UserProfile'
import { userProfileSelector } from 'src/store/auth/auth.selector'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DataTestId, TextConstants } from 'src/constants/ui.constants'

const { ExpertsEngine } = TextConstants.Header

const HeaderComp = () => {
    const profile = useSelector(userProfileSelector)
    const navigate = useNavigate()

    return (
        <Header className={classes.topBar} data-testid={DataTestId.Header}>
            <div className={classes.topBarContent}>
                <div className={classes.logoContainer} onClick={() => navigate('/')}>
                    <img
                        src={TelusLogo}
                        alt="Telus International Logo"
                        className="logo"
                        data-testid={DataTestId.TelusLogo}
                    />
                    <div className={classes.iconTitle}>{ExpertsEngine}</div>
                </div>
                <div className={classes.topbarRight}>
                    <UserProfile
                        userName={profile.first_name + ' ' + profile.last_name}
                        userEmail={profile.email}
                        alignText="end"
                    />
                </div>
            </div>
        </Header>
    )
}

export default HeaderComp
